import { EventDetail } from "../../_interfaces/eventDetail";
import { IEventFormatter } from "./ievent-formatter";

export class GenericDiffFormatter implements IEventFormatter {
  public format(properties: any, type_id: string): EventDetail[] {
    const changes = properties.changes || {};
    const formattedMessages: EventDetail[] = [];

    // Gère les changements de valeurs (e.g., nom, description)
    if (changes.values_changed) {
      for (const key in changes.values_changed) {
        const fieldName = this.extractFieldName(key);
        const oldValue = changes.values_changed[key].old_value;
        const newValue = changes.values_changed[key].new_value;

        // Évite les messages génériques pour les champs qui seront gérés autrement
        if (fieldName === 'skills' || fieldName === 'roles') {
          continue;
        }

        formattedMessages.push({
          key: 'EVENTS.CHANGE.VALUE',
          params: { field: fieldName, oldValue: oldValue, newValue: newValue }
        });
      }
    }

    // Gère les éléments ajoutés dans une collection
    if (changes.iterable_item_added) {
      for (const key in changes.iterable_item_added) {
        const fieldName = this.extractFieldName(key);
        const addedValue = changes.iterable_item_added[key];

        // Gère spécifiquement l'ajout d'une compétence
        if (fieldName === 'skills' && addedValue && addedValue.name) {
          formattedMessages.push({
            key: 'EVENTS.CHANGE.SKILL_ADDED',
            params: { skillName: addedValue.name }
          });
        } else if (fieldName === 'roles' && addedValue && addedValue.role && addedValue.role.name) {
          // Gère spécifiquement l'ajout d'un rôle (si vous l'implémentez)
          formattedMessages.push({
            key: 'EVENTS.CHANGE.ROLE_ADDED',
            params: { roleName: addedValue.role.name }
          });
        } else {
          // Gère tous les autres ajouts de manière générique
          formattedMessages.push({
            key: 'EVENTS.CHANGE.ITEM_ADDED',
            params: { field: fieldName, value: addedValue }
          });
        }
      }
    }

    // Gère les éléments retirés d'une collection
    if (changes.iterable_item_removed) {
      for (const key in changes.iterable_item_removed) {
        const fieldName = this.extractFieldName(key);
        const removedValue = changes.iterable_item_removed[key];

        // Gère spécifiquement la suppression d'une compétence
        if (fieldName === 'skills' && removedValue && removedValue.name) {
          formattedMessages.push({
            key: 'EVENTS.CHANGE.SKILL_REMOVED',
            params: { skillName: removedValue.name }
          });
        } else if (fieldName === 'roles' && removedValue && removedValue.name) {
          // Gère spécifiquement la suppression d'un rôle
          formattedMessages.push({
            key: 'EVENTS.CHANGE.ROLE_REMOVED',
            params: { roleName: removedValue.name }
          });
        } else {
          // Gère toutes les autres suppressions de manière générique
          formattedMessages.push({
            key: 'EVENTS.CHANGE.ITEM_REMOVED',
            params: { field: fieldName, value: removedValue }
          });
        }
      }
    }

    // Gère le cas où des changements existent mais n'ont pas été formatés
    if (formattedMessages.length === 0 && Object.keys(changes).length > 0) {
      formattedMessages.push({
        key: 'EVENTS.CHANGE.UNKNOWN',
        params: {}
      });
    }

    return formattedMessages;
  }

  /**
   * Helper method to extract a field name from a DeepDiff path string.
   * @param key The path string from DeepDiff (e.g., "root['skills'][0]").
   * @returns The extracted field name (e.g., "skills").
   */
  private extractFieldName(key: string): string {
    const match = key.match(/\[(.*?)\]/);
    if (!match) {
      return key; // Si pas de match, on renvoie la clé telle quelle (e.g., "name")
    }
    // Si c'est un tableau (ex: root['skills'][0]), on veut juste 'skills'
    return match[1].replace(/'/g, '').replace(/\[.*\]$/, '');
  }
}
